"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PixelsResponseToJSON = exports.PixelsResponseFromJSONTyped = exports.PixelsResponseFromJSON = exports.instanceOfPixelsResponse = void 0;
var runtime_1 = require("../runtime");
var Paging_1 = require("./Paging");
var Pixel_1 = require("./Pixel");
/**
 * Check if a given object implements the PixelsResponse interface.
 */
function instanceOfPixelsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPixelsResponse = instanceOfPixelsResponse;
function PixelsResponseFromJSON(json) {
    return PixelsResponseFromJSONTyped(json, false);
}
exports.PixelsResponseFromJSON = PixelsResponseFromJSON;
function PixelsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'pixels': !(0, runtime_1.exists)(json, 'pixels') ? undefined : (json['pixels'].map(Pixel_1.PixelFromJSON)),
    };
}
exports.PixelsResponseFromJSONTyped = PixelsResponseFromJSONTyped;
function PixelsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'pixels': value.pixels === undefined ? undefined : (value.pixels.map(Pixel_1.PixelToJSON)),
    };
}
exports.PixelsResponseToJSON = PixelsResponseToJSON;
